<div id="word-details-modal-root">
  <ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="wordCard && !isAudioPlaying()" (click)="vocalize()">
        <ion-icon *ngIf="!loadingAudio" name="volume-high-outline"></ion-icon>
        <ion-spinner *ngIf="loadingAudio"></ion-spinner>
      </ion-button>
      <ion-button *ngIf="wordCard && isAudioPlaying()" (click)="stopAudio()">
        <ion-icon name="stop-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons *ngIf="!studying && wordCard && !loading">
        <ion-button id="study-button" slot="start" [disabled]="wordCard === undefined || loading || sign_in_message || temp_user_message" (click)="studyWord()">
          <ion-icon name="add-circle-outline" slot="end"></ion-icon>
          {{ 'WORD_DETAILS.LEARN_WORD' | translate }} 
        </ion-button>
    </ion-buttons>
    <ion-buttons *ngIf="studying  && wordCard && !loading">
        <ion-button id="learning-button" slot="start" [disabled]="true">
          <ion-icon name="checkmark-circle-outline" slot="end"></ion-icon>
          {{ 'WORD_DETAILS.CURRENTLY_LEARNING' | translate }}
        </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ng-container *ngIf="loading">
    <ion-spinner name="dots"></ion-spinner>
    <div style="margin-top: 1rem;">
      <p>{{ 'LOADING' | translate }}</p>
    </div>
  </ng-container>
  <ng-container *ngIf="wordCard && wordCard.root_word; else noWordCard">
    <div *ngIf="sign_in_message" id="sign-in-message">
      <p> {{ 'WORD_DETAILS.SIGN_IN' | translate }} </p>
      <ion-button id="login-button" (click)="goToLogin()">
        <ion-icon name="log-in"></ion-icon>
        {{ 'WORD_DETAILS.GO_TO_SIGN_IN' | translate }}
      </ion-button>
    </div>
    <div *ngIf="temp_user_message" id="temp-user-message">
      <p> {{ 'WORD_DETAILS.TEMP_USER' | translate }} </p>
      <ion-button id="login-button" (click)="goToSignUp()">
        <ion-icon name="log-in"></ion-icon>
        {{ 'WORD_DETAILS.GO_TO_SIGN_UP' | translate }}
      </ion-button>
    </div>
    <h1>{{ wordCard.root_word}}</h1>
    <h3>{{ wordCard.translation }}</h3>
    <div *ngFor="let example of wordCard.examples; let i = index">
      <p><strong>{{ example }}</strong></p>
      <p>{{ wordCard.example_translations[i] }}</p>
    </div>
  </ng-container>
  <ng-template #noWordCard>
      <p *ngIf="!loading" class="error"> {{ 'WORD_DETAILS.WORD_NOT_FOUND' | translate }} </p>
  </ng-template>
  <ng-container *ngIf="!loading && error">
    <p class="error">{{ 'WORD_DETAILS.ERROR_LOADING' | translate }}</p>
  </ng-container>
</ion-content>
</div>